<template>
  <div>
    <section>
      <h1 class="title">Create Account</h1>

      <b-field label="Email">
        <b-input
          type="email"
          v-model="email"
          placeholder="Your email"
          key="user-email"
          required
          size="is-medium">
        </b-input>
      </b-field>

      <b-field label="Password">
        <b-input
          name="password"
          type="password"
          key="user-password"
          v-model="password"
          placeholder="Choose password"
          v-validate="'required|min:8|verify_password'"
          ref="password"
          size="is-medium"
        >
        </b-input>
      </b-field>
      <b-notification type="is-warning" v-show="errors.has('password')">
        {{ errors.first('password') }}
      </b-notification>

      <b-field label="Password Confirmation">
        <b-input
          name="password_confirmation"
          type="password"
          key="user-password"
          v-model="passwordConfirmation"
          v-validate="'required|confirmed:password'"
          placeholder="Password, Again"
          data-vv-as="password"
          size="is-medium"
        >
        </b-input>
      </b-field>
      <b-notification  type="is-warning" v-show="errors.has('password_confirmation')">
        {{ errors.first('password_confirmation') }}
      </b-notification>

      <button :disabled="errors.any() || !isCompleted" class="button is-success is-medium"
              @click="onRegisterClick">Register</button>
      <hr />
      <button class="button" @click="$router.push('/')">I already have an account</button>
    </section>

  </div>
</template>

<script>
import {
  CognitoUserPool, CognitoUserAttribute,
} from 'amazon-cognito-identity-js';

const USER_POOL_ID = 'us-east-1_W19nxF3iD';
const CLIENT_ID = '2cndfls54vvsqeiv1gccdkmbqn';

export default {
  name: 'auth-modal',
  data() {
    return {
      email: null,
      password: null,
      passwordConfirmation: null,
    };
  },
  computed: {
    isCompleted() {
      return this.email && this.password && this.passwordConfirmation;
    },
  },
  methods: {
    onRegisterClick() {
      const poolData = {
        UserPoolId: USER_POOL_ID,
        ClientId: CLIENT_ID,
      };
      const userPool = new CognitoUserPool(poolData);
      const attributeList = [];
      const formattedEmail = this.email.toLowerCase();
      const dataEmail = {
        Name: 'email',
        Value: formattedEmail,
      };

      const attributeEmail = new CognitoUserAttribute(dataEmail);

      attributeList.push(attributeEmail);

      const userName = formattedEmail;
      const password = this.password;
      userPool.signUp(userName, password, attributeList, null, (err, result) => {
        if (err) {
          alert(err.message);
          return;
        }
        // const cognitoUser = result.user;
        alert('Please check your email for a verification link to your new user account.');
        this.$router.push({ name: 'sign-in' });
        // console.log(`user name is ${cognitoUser.getUsername()}`);
      });
    },

  },
};
</script>
